import React, { useState } from "react";

import VisibilitySensor from "react-visibility-sensor";
import { CTooltip } from '@coreui/react'
import { trackWhatsApp, buildWhatsAppText } from "../utils/tracking";
import whats from "../assets/img/mediaButtons/whatsapp3.webp";

function MediaButtonsOrange({message}) {
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility>
      <div className={`mediaButtonsOrange ${isVisible ? "visible" : ""}`}>
        <CTooltip
          content="Quero fazer uma cotação!"
          placement="right"
        >
          <a
            href={
              "https://wa.me/5547992246105?text=" +
              buildWhatsAppText(
                message
              )
            }
            target="_blank"
            rel="noreferrer"
            onClick={() => trackWhatsApp("botao_flutuante")}
          >
            <img src={whats} alt="logotipo do whatsapp" width={"55px"} />
          </a>
        </CTooltip>
      </div>
    </VisibilitySensor>
  );
}
export default MediaButtonsOrange;
